import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import 'react';
import { maxWidthLayoutStyles } from '../../utils/styleHelpers.js';
import { jsx } from 'react/jsx-runtime';

var _templateObject, _templateObject2;
const Container = /*#__PURE__*/styled.footer.withConfig({
  displayName: "pageFooter__Container",
  componentId: "sc-1ij57np-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  background-color: ", ";\n\n  ", " {\n    padding: ", ";\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.threeQuarterSpacing;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.surface;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.mediaQueries.md;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return "".concat(theme.spacing.threeQuarterSpacing, " ").concat(theme.spacing.doubleSpacing);
});
const Inner = /*#__PURE__*/styled.div.withConfig({
  displayName: "pageFooter__Inner",
  componentId: "sc-1ij57np-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), _ref5 => {
  let {
    fullWidth
  } = _ref5;
  return !fullWidth && maxWidthLayoutStyles;
});
const PageFooter = _ref6 => {
  let {
    children,
    fullWidth,
    ...rest
  } = _ref6;
  return /*#__PURE__*/jsx(Container, {
    ...rest,
    children: /*#__PURE__*/jsx(Inner, {
      fullWidth: fullWidth,
      children: children
    })
  });
};

export { PageFooter };
